/**
 * tour.js — tiny one-shot tooltip orchestration.
 *
 * Two hints total. Each fires once per browser, ever, then is forgotten.
 * Lives in localStorage so it survives reloads but resets on storage
 * clear (private mode, fresh device). No server roundtrip, no SDK.
 *
 * KEYS:
 *   moodcard.tour.<id> = "seen" | undefined
 *
 * Pattern:
 *   import { tourHasSeen, tourMarkSeen } from "../lib/tour";
 *   if (!tourHasSeen("results-flick")) showHint(...);
 *   onDismiss = () => tourMarkSeen("results-flick");
 */
const PREFIX = "moodcard.tour.";

export function tourHasSeen(id) {
    if (!id) return true;  // defensive — never block on bad id
    try {
        return window.localStorage.getItem(`${PREFIX}${id}`) === "seen";
    } catch {
        // localStorage blocked → don't keep showing the hint forever in a
        // tab; treat as seen for safety.
        return true;
    }
}

export function tourMarkSeen(id) {
    if (!id) return;
    try { window.localStorage.setItem(`${PREFIX}${id}`, "seen"); } catch { /* ignore */ }
}

/** For debugging: window.__moodcardResetTour() in console nukes all hints. */
if (typeof window !== "undefined") {
    window.__moodcardResetTour = () => {
        try {
            Object.keys(window.localStorage)
                .filter((k) => k.startsWith(PREFIX))
                .forEach((k) => window.localStorage.removeItem(k));
            // eslint-disable-next-line no-console
            console.log("moodcard tour reset — refresh to see hints again.");
        } catch { /* ignore */ }
    };
}
